import { makeObservable } from 'mobx';

import { List } from '@store/abstract/List';

import { EntryTypeBlockData } from 'chaika-frontend-types/frontend-cms';

export class EntryTypeBlockList extends List<EntryTypeBlockData, EntryTypeBlockData, string> {
    constructor(params?: EntryTypeBlockData[]) {
        super(params);
        makeObservable(this);

        this.filterParams = '';
    }

    protected create(params: EntryTypeBlockData): EntryTypeBlockData {
        return params;
    }

    protected filterValue(value: EntryTypeBlockData, filterParams: string): boolean {
        return (
            value.title.toLocaleLowerCase().includes(filterParams.toLocaleLowerCase()) ||
            value.name.toLocaleLowerCase().includes(filterParams.toLocaleLowerCase())
        );
    }
}
